import { render, staticRenderFns } from "./thirdProductClassify.vue?vue&type=template&id=3480e970&scoped=true"
import script from "./thirdProductClassify.vue?vue&type=script&lang=js"
export * from "./thirdProductClassify.vue?vue&type=script&lang=js"
import style0 from "./thirdProductClassify.vue?vue&type=style&index=0&id=3480e970&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480e970",
  null
  
)

export default component.exports